import { RemoteVideo } from './RemoteVideo'
import { useRemoteMediaTrackState } from '../hooks/useRemoteMediaTrackState'
import { RemoteVideoOffContent } from './RemoteVideoOffContent'

export function BackgroundLayer() {
  const { isVideoTrackOn } = useRemoteMediaTrackState()

  return (
    <div className='absolute bottom-0 left-0 right-0 top-0 flex h-full flex-col items-center justify-center'>
      {isVideoTrackOn ?
        <RemoteVideo />
      : <RemoteVideoOffContent />}
    </div>
  )
}
